import get from 'lodash/get';
import { alerts } from '../actionTypes/alerts.js';

const startFetchingAlertSummaryDataByProperty = () => ({
  type: alerts.START_FETCHING_ALERT_SUMMARY_DATA_PROPERTY
});

const successFetchingAlertSummaryDataByProperty = payload => ({
  type: alerts.SUCCESS_FETCHING_ALERT_SUMMARY_DATA_PROPERTY,
  payload
});

const errorFetchingAlertSummaryDataByProperty = payload => ({
  type: alerts.FAILURE_FETCHING_ALERT_SUMMARY_DATA_PROPERTY,
  payload
});

export const clearAlertSummaryDataByProperty = () => ({
  type: alerts.CLEAR_ALERT_SUMMARY_DATA_PROPERTY
});

export const fetchAlertSummaryDataByProperty = filters => {
  return (dispatch, getState) => {
    const { field_name, direction } = getState().sortReducer;

    return new Promise((resolve, reject) => {
      dispatch(startFetchingAlertSummaryDataByProperty());

      dispatch({
        hmsFetchConfig: {
          path: '/hms_ms/api/v1/generic',
          method: 'POST',
          body: {
            data_tag: 'DATATAG_DELIGHTIQ_ALERT_SUMMARY_BY_PROPERTY',
            request_data: {
              sort: {
                field_name,
                direction
              },
              filters
            }
          }
        },

        onSuccess: ({ data }) => {
          const res = get(data, 'data.api_response.APITAG_DELIGHTIQ_ALERT_SUMMARY_BY_PROPERTY.data', []);

          dispatch(
            successFetchingAlertSummaryDataByProperty({
              alerts_summary_data_property: res
            })
          );

          resolve(res);
        },

        onError: ({ error }) => {
          dispatch(errorFetchingAlertSummaryDataByProperty({ error }));
          reject(error);
        }
      });
    });
  };
};
